export enum USAGE_TYPE_ENUM {
  SMS = 1,
  Email = 2,
  Home_Affairs_Lookup = 3,
  Whatsapp = 4
};

export const USAGE_TYPE = [
  { label: 'SMS', value: 1 },
  { label: 'Email', value: 2 },
  { label: 'Home Affairs Lookup', value: 3 },
  { label: 'Whatsapp', value: 4 }
];

/**
 * Format Local Date to UTC ISO string and set time to start (00:00:00.000) or end of day (23:59:59.999)
 * @param date
 * @param isEndOfDay - if true, set time to end of day, otherwise start of day
 */
export const formatLocalDateAsUtc = (date: Date, isEndOfDay: boolean) => {
  const d = new Date(date);
  if (isEndOfDay) {
    d.setHours(23, 59, 59, 999);
  } else {
    d.setHours(0, 0, 0, 0);
  }
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');
  const milliseconds = String(d.getMilliseconds()).padStart(3, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
};